import { render, staticRenderFns } from "./PwaVehicleDetail.vue?vue&type=template&id=3c1e2200&scoped=true"
import script from "./PwaVehicleDetail.vue?vue&type=script&lang=js"
export * from "./PwaVehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./PwaVehicleDetail.vue?vue&type=style&index=0&id=3c1e2200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e2200",
  null
  
)

export default component.exports